import { Users, Clock, Crown, Code2, LineChart, FileText, MessageSquare, Compass } from "lucide-react";
import { Reveal, SectionLabel } from "./motion";

const SERVICES = [
  { icon: Users, title: "Permanent Recruitment", body: "Full-time hires vetted for skill, culture and long-term fit." },
  { icon: Clock, title: "Temporary Staffing", body: "Flexible staffing that scales with your workload and season." },
  { icon: Crown, title: "Executive Search", body: "Discreet headhunting for senior leaders and C-suite roles." },
  { icon: Code2, title: "IT Recruitment", body: "Developers, DevOps, data and product talent on demand." },
  { icon: LineChart, title: "HR Consulting", body: "Org design, policy and talent strategy from senior HR advisors." },
  { icon: FileText, title: "Resume Writing", body: "ATS-friendly resumes written by recruitment insiders." },
  { icon: MessageSquare, title: "Interview Preparation", body: "Mock interviews and coaching that turn shortlists into offers." },
  { icon: Compass, title: "Career Counseling", body: "One-on-one guidance to map your next career move." },
];

export default function Services() {
  return (
    <section id="services" className="bg-[#F4F5F7] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-testid="services-section">
      <SectionLabel number="04" text="What We Do" />
      <Reveal>
        <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0A1128] mb-16 max-w-3xl">
          Every hiring problem, <span className="text-[#1D4ED8]">one partner.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0A1128]/10 border border-[#0A1128]/10" data-testid="services-grid">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 4) * 0.06}>
            <div
              className="group bg-white hover:bg-[#0A1128] p-8 md:p-10 h-full transition-colors duration-500"
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <s.icon size={28} className="text-[#1D4ED8] mb-8" strokeWidth={1.5} />
              <h3 className="font-display font-bold text-xl tracking-tight text-[#0A1128] group-hover:text-white mb-3 transition-colors duration-500">
                {s.title}
              </h3>
              <p className="text-sm text-[#475569] group-hover:text-white/60 font-light leading-relaxed transition-colors duration-500">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
